module.exports = __webpack_public_path__ + "img/root110.dcaef4af.png";